<template>
  <div>
      <topTab :changeTabIndex='3'></topTab>
      <androidpage></androidpage>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import androidpage from "@/components/android/android.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'home',
  components: {
    androidpage,
    bottomMsg,
    topTab
  }
}
</script>
